import { render, staticRenderFns } from "./module-title.vue?vue&type=template&id=5ad7b62a"
import script from "./module-title.vue?vue&type=script&lang=js"
export * from "./module-title.vue?vue&type=script&lang=js"
import style0 from "./module-title.vue?vue&type=style&index=0&id=5ad7b62a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports